import { render, staticRenderFns } from "./ChatPP.vue?vue&type=template&id=86f64bb0&scoped=true"
import script from "./ChatPP.vue?vue&type=script&lang=js"
export * from "./ChatPP.vue?vue&type=script&lang=js"
import style0 from "./ChatPP.vue?vue&type=style&index=0&id=86f64bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f64bb0",
  null
  
)

export default component.exports